var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaEuropea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 18,
    viewBox: "0 0 172 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_5664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18V14.35H4.81621V1H0.5V18H13.5Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18H18.7618L19.9401 14.875H27.085L28.2382 18H32.5L26.032 1H21.0933L14.5 18ZM23.5752 5.15L26.032 11.8H20.993L23.5752 5.15Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 18V14.35H45.6026V11.1H53.6282V7.575H45.6026V4.65H55.5V1H41.5V18H55.5Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7464 0H58.5V10.1071C58.5 14.6918 61.331 18 66.4621 18C71.669 18 74.5 14.3531 74.5 10.1071V0H70.2536V9.82055C70.2536 12.3213 68.9897 13.9363 66.4621 13.9363C64.0103 13.9363 62.7464 12.3734 62.7464 9.82055V0Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 17.7391H82.7124V11.3478H83.615C85.8466 12.9391 88.705 18 92.6165 18C93.7699 18 94.7979 17.687 95.5 17.3217L95.0988 13.8783C94.5723 14.113 93.8451 14.2174 93.2935 14.2174C91.7139 14.2174 90.2094 12.6522 88.6799 11.1913C91.2625 10.6435 93.1431 8.63478 93.1431 5.84348C93.1431 1.69565 89.9086 0 86.5988 0H78.5V17.7391ZM86.5236 3.8087C87.9027 3.8087 88.7802 4.64348 88.7802 6C88.7802 7.30435 87.9027 8.1913 86.5236 8.1913H82.7124V3.8087H86.5236Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 9.02571C97.5 14.1429 101.357 18 106.474 18C111.643 18 115.5 14.1429 115.5 9.02571C115.5 3.85714 111.643 0 106.474 0C101.357 0 97.5 3.85714 97.5 9.02571ZM101.743 9.02571C101.743 6.19714 103.749 4.08857 106.5 4.08857C109.329 4.08857 111.257 6.19714 111.257 9.02571C111.257 11.8029 109.329 13.9371 106.5 13.9371C103.749 13.9371 101.743 11.8029 101.743 9.02571Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 18H123.778V13.5H128.108C131.546 13.5 134.5 11.175 134.5 7.3C134.5 2.975 131.546 1 128.108 1H119.5V18ZM127.42 4.65C128.923 4.65 130.069 5.625 130.069 7.275C130.069 8.825 128.923 9.85 127.42 9.85H123.778V4.65H127.42Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5 18V14.35H141.603V11.1H149.628V7.575H141.603V4.65H151.5V1H137.5V18H151.5Z",
    fill: "#253157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5 18H157.762L158.94 14.875H166.085L167.238 18H171.5L165.032 1H160.093L153.5 18ZM162.575 5.15L165.032 11.8H159.993L162.575 5.15Z",
    fill: "#253157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_5664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaEuropea);
export default __webpack_public_path__ + "static/media/la_europea.fa02897712176cd293148a9ec5643d32.svg";
export { ForwardRef as ReactComponent };